exports.default = {
  'paiteams': 'PAITEAMS',
  'discover': '發現',
  'home': '首頁',
  'conversation': '對話',
  'projects': '項目',
  'assets': '資產',
  'account_settings': '賬號設置',
  'my_sub': '我的訂閱',
  'upgrade': '升級',
  'upgrade_to_pro': '升級至專業版',
  'language': '語言',
  'theme': '主題',
  'logout': '退出登錄',
  'team_invitation': '團隊邀請',
  'confirm': '確 定',
  'create_team': '創建團隊',
  'cancel': '取 消',
  'join_team': '加入團隊',
  'leave_team': '離開團隊',
  'confirm_leave_team': '確定要離開目前團隊嗎？離開後將無法繼續訪問該團隊資源。',
  'leave_team_success': '已離開團隊',
  'confirm_logout': '確定退出系統嗎？',
  'logout_system': '退出系統',
  'exit': '退出',
  'return_to_agentstore': '返回 AgentStore',
  'exit_management': '退出管理',
  'team_management': '團隊管理',
  'organization_info': '組織信息',
  'member_management': '成員管理',
  'team_settings': '團隊設置',
  'member_department': '成員部門',
  'member_approval': '成員審批',
  'role_management': '角色管理',
  'limit_management': '限額管理',
  'consumption_records': '消費記錄',
  'no_management_permission': '你沒有管理權限！',
  'current_team': '當前團隊',
  'personal_team': '個人團隊',
  'enterprise_team': '企業團隊',
  'available_points': '可用積分',
  'light': '淺色',
  'dark': '深色',
  'system': '跟隨系統',
  'invite_reward': '邀請獎勵',
  'invite_reward_tip': '邀請朋友可獲得免費積分',
  'refer_friend': '推薦朋友',
  'bind_invite_code': '填寫邀請碼',
  'free_credits': '免費積分',
  'contact_us': '聯繫我們',
  'enterprise_contact': '企微聯繫',
  'enterprise_dialog_heading': '企業創作，從此協作有序',
  'enterprise_dialog_intro': '為團隊整合協作、素材與成員管理，讓創作流程更清晰。',
  'enterprise_benefit_collaboration': '團隊協作',
  'enterprise_benefit_collaboration_desc': '統一團隊創作流程，減少溝通與交接成本。',
  'enterprise_benefit_brand': '品牌規範',
  'enterprise_benefit_brand_desc': '集中管理品牌素材與使用標準。',
  'enterprise_benefit_assets': '素材管理',
  'enterprise_benefit_assets_desc': '團隊資產統一沉澱，查找和複用更高效。',
  'enterprise_benefit_flexible': '彈性配置',
  'enterprise_benefit_flexible_desc': '根據團隊規模配置用量與服務權益。',
  'enterprise_benefit_members': '成員管理',
  'enterprise_benefit_members_desc': '統一管理團隊成員與工作空間。',
  'enterprise_benefit_service': '專屬服務',
  'enterprise_benefit_service_desc': '企業顧問協助評估並配置合適方案。',
  'enterprise_service_custom': '按需配置權益',
  'enterprise_service_scale': '支援團隊擴展',
  'enterprise_service_advisor': '專屬顧問服務',
  'enterprise_advisor_title': '聯繫企業顧問',
  'enterprise_advisor_desc': '了解企業版方案、團隊規模與使用需求，我們將提供專屬諮詢。',
  'enterprise_qrcode_placeholder': '企微碼待補充',
  'enterprise_qrcode_hint': '企微碼確認後將在此顯示'
}
